import React from 'react';

import { SlideContextProvider } from '../../../slides';
import { premiumReportTheme } from '../../../slides/themes/assetmark/premium-report';
import { PremiumReport } from './premium-report';

export function PremiumReportPage(): React.ReactNode {
  return (
    <SlideContextProvider
      theme={premiumReportTheme}
      width={816}
      height={1056}
      // width={1056}
      // height={816}
      type="premium_report"
    >
      <PremiumReport />
    </SlideContextProvider>
  );
}
